/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_List_Recent_ConversationsInputs */



/**
* | output |
* | --- |
* | "Recent Conversations" |
*
* @param {Chat_List_Recent_ConversationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_list_recent_conversations = /** @type {((inputs?: Chat_List_Recent_ConversationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_List_Recent_ConversationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kürzliche Unterhaltungen")
	return /** @type {LocalizedString} */ ("Recent Conversations")
});